import { Pipe, PipeTransform } from '@angular/core';
import { HelperService } from '../Services/Helper.Service';

@Pipe({ name: 'aggrBy' })
export class AggrPipe implements PipeTransform {
    constructor(private helper: HelperService) { }
    transform(value: Array<any>, args: string): any {
        switch (args) {
            case 'min':
                return this.min(value);
            case 'max':
                return this.max(value);
            case 'sum':
                return this.sum(value);
            case 'avg':
                return this.avg(value);
            case 'prcnt':
                return this.percent(value);
            case 'product':
                return this.product(value);
            case 'range':
                return this.range(value);
            case 'midrange':
                return this.midrange(value);
            case 'median':
                return this.median(value);
            case 'var':
                return this.variance(value);
            case 'count':
                return value.filter(f => f !== null && f !== undefined && f.toString().trim() !== '').length;
            case 'dcount':
                return this.distinctCount(value);
            case 'stddvn':
                return this.standardDeviation(value);
            case 'absdvn':
                return this.meanAbsoluteDeviation(value);
            default:
                return this.sum(value);
        }
    }

    distinctCount(array: Array<any>): any {
        return this.helper.copyArray(Array.from(new Set(array))).length;
    }

    min(array: Array<any>): any {
        return Math.min(...array);
    }

    max(array: Array<any>): any {
        return Math.max(...array);
    }

    sum(array: Array<any>): any {
        return array.reduce((a, b) => a + b, 0);
    }

    avg(array: Array<any>): any {
        return (array.reduce((a, b) => a + b, 0)) / array.length;
    }

    percent(array: Array<any>): any {
        return (array.reduce((a, b) => a + b, 0)) / array.length;
    }

    product(array: Array<any>): any {
        return (array.reduce((a, b) => {
            return (a === '' || a === 0 ? 1 : a) * (b === '' || b === 0 ? 1 : b);
        }, 0));
    }

    range(array: Array<any>): any {
        return this.max(array) - this.min(array);
    }

    midrange(array: Array<any>): any {
        return this.range(array) / 2;
    }

    median(array: Array<any>): any {
        array.sort(function (a, b) {
            return a - b;
        });
        const mid = array.length / 2;
        return mid % 1 ? array[mid - 0.5] : (array[mid - 1] + array[mid]) / 2;
    }

    variance(array: Array<any>): any {
        const mean = this.avg(array);
        return this.avg(array.map(function (num) {
            return Math.pow(num - mean, 2);
        }));
    }

    standardDeviation(array: Array<any>): any {
        return Math.sqrt(this.variance(array));
    }

    meanAbsoluteDeviation(array: Array<any>): any {
        const mean = this.avg(array);
        return this.avg(array.map(function (num) {
            return Math.abs(num - mean);
        }));
    }
}
